import React from 'react';
import { PanelRightOpen } from 'lucide-react';

type ViewAllButtonProps = {
    onClick: () => void;
    label?: string;
    /** Distinct accessible name — needed when a page shows more than one View all. */
    ariaLabel?: string;
    /** The icon signals a side panel; turn it off when the target is a centre modal. */
    showPanelIcon?: boolean;
};

// The shared "view the full list" affordance. Existing
// inline versions (ThreatenedSpeciesWidget, SiteThreatenedSpeciesModal,
// RiskDriversList) should migrate here as they're touched.
const ViewAllButton = ({ onClick, label = 'View all', ariaLabel, showPanelIcon = true }: ViewAllButtonProps) => (
    <button type='button' onClick={onClick} aria-label={ariaLabel} className='flex items-center gap-2 text-sm font-medium text-primary'>
        {label}
        {showPanelIcon && <PanelRightOpen className='h-4 w-4' />}
    </button>
);

export default ViewAllButton;
